import type { ReactNode } from 'react';
import { cx } from '@/lib/cx';

/** Shown when a surface has nothing to display — always says what to do next. */
export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cx('flex flex-col items-center gap-2 px-6 py-12 text-center', className)}>
      {icon && (
        // Plain muted glyph, no framed tile — the tile read as decoration.
        <span aria-hidden="true" className="mb-1 grid place-items-center text-fg-subtle">
          {icon}
        </span>
      )}
      <p className="text-sm font-medium text-fg">{title}</p>
      {description && <p className="max-w-sm text-xs text-fg-muted">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
